'use client';

import CWImage from '@/context/global/components/g00/g00-d00-g003-cw-image-fallback';
import CWButton from '@/context/global/components/g00/g00-d00-g006-cw-button';
import { cn } from '@/context/global/utils/cn';
import { useTranslations } from 'next-intl';
import React from 'react';

type TConfirmDeleteFavorite = {
  isOpen: boolean;
  onClose?: () => void;
  className?: string;
};

const CWModalAdvert = ({ isOpen, onClose, className }: TConfirmDeleteFavorite) => {
  const t = useTranslations();
  if (!isOpen) return null;

  const handleOverlayClick = (e: React.MouseEvent) => {
    if (e.target === e.currentTarget) {
      onClose?.();
    }
  };

  return (
    <div
      className="fixed inset-0 z-50 flex items-center justify-center bg-black/50 p-2 sm:p-4"
      onClick={handleOverlayClick}
    >
      <div
        className={cn(
          'relative flex max-h-[90vh] w-[90vw] max-w-[420px] flex-col items-center justify-center gap-3 overflow-hidden rounded-[12px] py-4 sm:gap-4 sm:rounded-[16px] md:max-w-[480px] md:gap-6 md:rounded-[20px]',
          className,
        )}
      >
        {/* Gradient overlay — จอเล็ก gradient เริ่มต่ำกว่า, จอใหญ่เริ่มสูงกว่า */}
        <div
          className="pointer-events-none absolute inset-0 sm:hidden"
          style={{
            background:
              'linear-gradient(180deg, rgba(67, 67, 67, 0) 30.76%, #000000 69.73%)',
          }}
        />
        <div
          className="pointer-events-none absolute inset-0 hidden sm:block"
          style={{
            background:
              'linear-gradient(180deg, rgba(67, 67, 67, 0) 30.76%, #000000 69.73%)',
          }}
        />

        <div className="relative w-full flex-1 overflow-hidden rounded-[8px] sm:rounded-[12px] md:rounded-[16px]">
          <CWImage
            src="/assets/platinum_advert.png"
            alt="Advertisement"
            width={700}
            height={784}
            className="h-auto w-full object-contain p-[32px]"
            loading="lazy"
          />
        </div>

        <div className="relative flex w-full max-w-[200px] items-center justify-center">
          <CWButton
            variant="white"
            onClick={onClose}
            title={t('Advert.close')}
            className="h-[40px] w-full border-white/10 text-[16px] font-medium sm:h-[50px] sm:text-[20px] md:h-[60px] md:text-[24px]"
            parentClassname="w-full"
          />
        </div>
      </div>
    </div>
  );
};

export default CWModalAdvert;
